import React from 'react';
import { Container, Panel, Label, PasswordField, Spacer, Button, FormPanel } from '@sencha/ext-modern'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { doChangePasswordUnLogin, doLogin } from '../reducers/actions'
import colors from '../components/colors'

const panelProps = {
    height: "100%",
    margin: '0 0 40 0',
}

class ChangePasswordUnLogin extends React.Component {
    state = {
        errorMessage: null,
        submitting: null,
        formData: {
            oldPassword: '',
            newPassword: '',
            checkPassword: '',
        }
    }
    setFocus = () => {
        window.focus()
        this.refs.password && this.refs.password.cmp.focus()
    }

    componentDidMount() {
        this.setFocus()
    }

    componentWillUnmount() {
        this.source && Ext.destroy(this.source);
    }

    handleBack = () => {
        this.props.history.push('/')
    }
    handleEnterKey = (obj) => {
        const name = obj.getName()
        name === 'oldPassword' && this.refs.newPassword && this.refs.newPassword.cmp.focus()
        name === 'newPassword' && this.refs.checkPassword && this.refs.checkPassword.cmp.focus()
        name == 'checkPassword' && this.handleSubmit()
    }

    handleInput = (obj, value) => {
        const { formData } = this.state
        const name = obj.getName()
        const newFormData = { [name]: value }
        const { newPassword, checkPassword, oldPassword } = { ...formData, ...newFormData }
        const errorMessage = (name === "newPassword" && !newPassword || name === "checkPassword" && !checkPassword) ? `密码不符合规范` :
            (checkPassword === newPassword ? (newPassword === oldPassword ? "新旧密码不能完全相同" : "") : "两次密码输入不一致")
        this.setState({ formData: { ...formData, ...newFormData }, errorMessage })
    }

    handleSubmit = () => {
        const { submitting, formData: { newPassword, oldPassword, checkPassword }, errorMessage } = this.state
        const { doChangePasswordUnLogin, doLogin, history, match: { params: { name } } } = this.props
        if (!name)
            return
        if (!oldPassword) {
            this.setState({ errorMessage: "旧密码不能为空" })
            return
        } else if (!newPassword) {
            this.setState({ errorMessage: "新密码不能为空" })
            return
        } else if (!checkPassword) {
            this.setState({ errorMessage: "请重复输入新密码" })
            return
        }
        if (submitting || errorMessage)
            return

        doChangePasswordUnLogin({
            oldPassword, newPassword, userName: name,
            onRequest: () => {
                this.setState({ submitting: true })
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    this.setState({ submitting: false, errorMessage })
                } else {
                    doLogin({
                        userName: name, password: newPassword,
                        onRequest: () => {
                            this.setState({ submitting: true })
                        },
                        onEnd: ({ errorMessage }) => {
                            if (errorMessage) {
                                this.setState({ submitting: false, errorMessage })
                            } else {
                                history.push('/')
                            }
                        }
                    })
                }
            }
        })
    }

    render() {
        const { errorMessage, submitting } = this.state
        return (
            <Panel shadow layout="fit" {...panelProps}>
                <Container layout={{ type: 'hbox', align: 'top', pack: "center" }} style={colors.card.grey} padding={Ext.os.is.Phone ? "20% 0 0 0" : "150 0 0 0"} ref="dragContainer">
                    <FormPanel shadow ref="dragItem"
                        padding="20"
                        title={`修改密码`}
                        iconCls="x-fa fa-key"
                        ui="light"
                        platformConfig={{ "!phone": { maxHeight: 500, width: 350, } }}>
                        <Label html={"请设置您的新密码，密码长度应不少于6位，并同时包括大写字符、小写字符和数字。"} />
                        <PasswordField label="旧密码"
                            name="oldPassword"
                            ref="oldPassword"
                            labelAlign="top"
                            required
                            placeholder="请输入旧密码"
                            requiredMessage="请输入旧密码"
                            onAction={this.handleEnterKey}
                            onChange={this.handleInput} />
                        <PasswordField label="新密码"
                            name="newPassword"
                            ref="newPassword"
                            labelAlign="top"
                            required
                            placeholder="请输入新密码"
                            requiredMessage="请输入新密码"
                            onAction={this.handleEnterKey}
                            onChange={this.handleInput} />
                        <PasswordField label="重复新密码"
                            name="checkPassword"
                            ref="checkPassword"
                            labelAlign="top"
                            required
                            placeholder="请再次输入新密码"
                            requiredMessage="请再次输入新密码"
                            onAction={this.handleEnterKey}
                            onChange={this.handleInput} />
                        {errorMessage ? <Label html={errorMessage} style={{ color: 'red' }} /> : <Spacer height="20" />}
                        <Spacer height="20" />
                        <Container layout='fit'>
                            <Button
                                ui="action raised"
                                iconCls={submitting && "x-fa fa-spinner fa-pulse" || "x-fa fa-floppy-o"}
                                text={"保存"}
                                width='40%'
                                handler={this.handleSubmit}
                            />
                            <Button
                                ui="action raised"
                                iconCls={"x-fa fa-arrow-left"}
                                text={"返回"}
                                width='40%'
                                margin='0 0 0 10'
                                handler={this.handleBack}
                            />
                        </Container>

                    </FormPanel>
                </Container>
            </Panel>
        )
    }
}

const mapStateToProps = () => ({})

export default compose(
    connect(mapStateToProps, { doChangePasswordUnLogin, doLogin }),
)(ChangePasswordUnLogin)
